import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
    display: flex;
    max-width: 300px;
    margin: 0 auto 10px;
    justify-content: flex-end;
`;

const StyledAnchor = styled.a`
    color: ${({ theme }) => theme.colors.turquoise100};
    font-size: 0.9em;
`;

export interface ForgotPasswordLinkProps {
    linkText: string;
    href: string;
}

const ForgotPasswordLink: FC<ForgotPasswordLinkProps> = ({ href, linkText }): ReactElement => (
    <StyledWrapper>
        <StyledAnchor href={href}>{linkText}</StyledAnchor>
    </StyledWrapper>
);

export default ForgotPasswordLink;
